import React from 'react';

const SpaceContext = React.createContext({})

export default SpaceContext;